import React from 'react';

export const CorpContactTab = (): JSX.Element => {
    return (
        <div className="tab-panel">
            <p>&nbsp;</p>
            <h5>ADDRESS</h5>
            <p>Verity Solutions</p>
            <p>12131 113th Ave NE</p>
            <p>Suite 200</p>
            <p>Kirkland, WA 98034</p>
            <p>&nbsp;</p>
            <h5>SUPPORT</h5>
            <p>
                <a href="tel:800.581.1378">800.581.1378</a>
            </p>
            <p>
                <a href="mailto:support@verity340b.com">Support@verity340b.com</a>
            </p>
            <p>&nbsp;</p>
            <h5>SALES</h5>
            <p>
                <a href="tel:425.947.1937">425.947.1937</a>
            </p>
            <p>
                <a href="mailto:sales@verity340b.com">Sales@verity340b.com</a>
            </p>
            <p>&nbsp;</p>
        </div>
    );
};

export const CorpAboutTab = (): JSX.Element => {
    return (
        <div className="tab-panel">
            <p>&nbsp;</p>
            <p>
                Founded in 2002, Verity Solutions provides 340B software and services to hundreds of integrated
                healthcare systems, acute-care hospitals, pharmacies, and other 340B-eligible covered entities
                throughout the United States. Verity offers dedicated account managers who provide focused support to
                maximize your 340B program success. Our people and software work hard to optimize your 340B savings and
                help you maintain 100% compliance through annual and quarterly mock audits. Verity Solutions is located
                in Kirkland, WA with remote employees stationed all across the nation to best serve our widespread
                customer base.
            </p>
            <p>&nbsp;</p>
            <p>
                Learn more about Verity Solutions Group, Inc. on the{' '}
                <a href="https://www.verity340b.com/">Corporate Website</a>
            </p>
            <p>&nbsp;</p>
        </div>
    );
};
